import React from 'react';

import { useIntl, FormattedMessage } from '../../../plugins/publicis-gatsby-plugin-i18n';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  LogoYellow,
  XIcon,
  YoutubeIcon,
} from '../../Atoms/Icons/Icons';
import Link from '../../Molecules/Link/Link';
import DiscoverStores from '../DiscoverStores/DiscoverStores';
import Dropdown from '../Dropdown/Dropdown';
import useMedias from '../../hooks/useMedias';

import './footer.scss';
let classNames = require('classnames');

const Footer = ({ imagesArray, footerContactMenu, footerBlock, socialMedia }) => {
  const { getImage } = useMedias();
  const intl = useIntl();
  let footerQuestions = [];
  let footerLegale = [];
  let footerSocialMedia = {};
  let index = 0;

  const onCookieManageClick = (e) => {
    e.preventDefault();
    Cookiebot.renew();
  };

  socialMedia.nodes.forEach((node) => {
    Object.assign(footerSocialMedia, { [node.title.toLowerCase()]: node.link.url });
  });

  if (footerContactMenu) {
    footerContactMenu.filter((item, i) => {
      if (item.node.menu_name === 'footer-nous-contacter') {
        footerQuestions.push({
          id: index++,
          label: item.node.title,
          link: item.node.link.url,
        });
      }

      if (item.node.menu_name === 'footer' && item.node.drupal_internal__id != 45) {
        footerLegale.push({
          id: i,
          label: item.node.title,
          link: item.node.link.url,
        });
      }
    });
  }
  return (
    <footer className='footer' id="footer" role="contentinfo">
      <div className="logoWrapper">
        <LogoYellow alt="Logo Colas" />
      </div>
      <div className="discover_store">
        <DiscoverStores
          position="footer"
        />
      </div>
      <div className="wrapper_page">
        <div className={classNames('contactWrap', 'left')}>
          <div className="contact">
            <div className="only_desktop">
              <p className="col_title"><FormattedMessage id="footer.cta.contactus" /></p>
              <ul>
                {footerQuestions.map((item) => (
                  <li key={item.id}>
                    <Link customClass="yellow-deco" href={item.link}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <Dropdown
              customClass="dropdown-questions-footer only_mobile_tablet"
              list={footerQuestions}
            ></Dropdown>
          </div>
          <div className="rs_container">
            <p className="col_title only_desktop"><FormattedMessage id="footer.cta.social" /></p>
            <ul className="links">
              <li>
                <Link customClass="icon" target="_blank" href={footerSocialMedia.linkedin} ariaLabel={intl.formatMessage({ id: 'ariaLabel.icon_linkedin' })}>
                  <LinkedinIcon />
                </Link>
              </li>
              <li>
                <Link customClass="icon" target="_blank" href={footerSocialMedia.twitter} ariaLabel={intl.formatMessage({ id: 'ariaLabel.icon_twitter' })}>
                  <XIcon />
                </Link>
              </li>
              <li>
                <Link customClass="icon" target="_blank" href={footerSocialMedia.facebook} ariaLabel={intl.formatMessage({ id: 'ariaLabel.icon_facebook' })}>
                  <FacebookIcon />
                </Link>
              </li>
              <li>
                <Link customClass="icon" target="_blank" href={footerSocialMedia.instagram} ariaLabel={intl.formatMessage({ id: 'ariaLabel.icon_insta' })}>
                  <InstagramIcon />
                </Link>
              </li>
              <li>
                <Link customClass="icon" target="_blank" href={footerSocialMedia.youtube} ariaLabel={intl.formatMessage({ id: 'ariaLabel.icon_youtube' })}>
                  <YoutubeIcon />
                </Link>
              </li>
            </ul>
          </div>
          {
            (footerBlock[0] && !footerBlock[0]?.node?.field_hidden) && (
              <div className="wysiwyg_container">
                {
                  footerBlock[0]?.node?.description && <p className='col_title'>{footerBlock[0]?.node?.description}</p>
                }
                {
                  footerBlock[0]?.node?.field_texte?.value && <div dangerouslySetInnerHTML={{ __html: footerBlock[0]?.node?.field_texte?.value }}></div>
                }

              </div>
            )
          }
        </div>
      </div>
      <div className="linkWrap wrapper_page">
        <ul className="list_links">
          {footerLegale.map((item) => (
            <li key={item.id}>
              <Link href={item.link}>
                {item.label}
              </Link>
            </li>
          ))}
          <li><a href="#" className="links" onClick={onCookieManageClick}><FormattedMessage id="footer.manage_cookies" /></a></li>
        </ul>
        <FormattedMessage id="footer.copyright">{x => <p className="copyright" >{x}</p>}</FormattedMessage>
      </div>

    </footer>
  );
};

export default Footer;
